export const COMPLETION_MESSAGES = [
  '全部すっきり！今日の振り分け、完璧です。',
  'お見事！予定の整理がきれいに終わりました。',
  'さすがです！パンダも安心して見守れます。',
  'きれいに片付きました。判断が早くて素敵です！',
  '振り分け完了！今日もいい仕事でした。',
  '全部確認できました。すばらしい集中力です！',
  '予定ボックスが空になりました。気持ちいいですね！',
  'お疲れさまでした！大切な予定を、きちんと残せています。',
] as const;

export function pickCompletionMessage(random = Math.random): string {
  return COMPLETION_MESSAGES[Math.floor(random() * COMPLETION_MESSAGES.length)] ?? COMPLETION_MESSAGES[0];
}
